export default __webpack_public_path__ + "static/media/eco.7941b8d6.svg";